<form [formGroup]="identityVerificationForm">
  <rkt-form [form]="identityVerificationForm" [fields]="formFields" [model]="formModel"></rkt-form>

  <div class="linx-request-buttons">
    <button rktButton btnType="tertiary" class="linx-request-btn btn-clear" title="Clear" (click)="onClearBtnClick()">Clear</button>

    <button rktButton title="Continue" [disabled]="identityVerificationForm.invalid" (click)="onSubmit()">Continue</button>
  </div>
</form>
